import { render, staticRenderFns } from "./CommodityEdit.vue?vue&type=template&id=64e5483e&scoped=true"
import script from "./CommodityEdit.vue?vue&type=script&lang=js"
export * from "./CommodityEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e5483e",
  null
  
)

export default component.exports